import { cn } from "@/lib/utils";

/** Shared segment chrome for DeskSubNav + DeskDocTabs — plan/35. */
export function deskSegmentNavClass(
  ...classNames: Array<string | undefined>
): string {
  return cn(
    "mt-4 -mx-1 flex max-w-full gap-0.5 overflow-x-auto px-1 pb-0.5",
    "[scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
    ...classNames,
  );
}

export function deskSegmentListClass(): string {
  return "inline-flex min-w-0 rounded-[var(--radius-xl)] border border-[var(--color-border)]/90 bg-[var(--color-card)]/85 p-1 shadow-[var(--shadow-soft)]";
}

export function deskSegmentItemClass(active: boolean): string {
  return cn(
    "shrink-0 rounded-lg px-3 py-2 text-sm transition-colors",
    active
      ? "bg-[var(--color-background)] font-medium text-[var(--color-foreground)] shadow-[var(--shadow-soft)]"
      : "text-[var(--color-muted)] hover:text-[var(--color-foreground)]",
  );
}
